import { Component } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  FormCompletionService,
  FormCompletionStates,
} from "../../services/form-completion/form-completion.service";

@Component({
  selector: "app-online-form",
  templateUrl: "./online-form.component.html",
  styleUrls: ["./online-form.component.scss"],
  providers: [FormCompletionService],
})
export class OnlineFormComponent {
  public states = FormCompletionStates;

  public get isProduction() {
    return !!environment.production;
  }

  constructor(private formCompletionService: FormCompletionService) {}

  // Helper function
  get service() {
    return this.formCompletionService;
  }
}
